import React, { Component } from "react";
import { connect } from "react-redux";
import { Link, Redirect } from 'react-router-dom';
import { FormHeader } from '../formHeader/formHeader';
import './aplicationform.scss';
import { apis } from '../../actions';
import util from '../../_helpers/util';
import {
  jobApplicationStatus,
  jobApplicationEditStatus,
} from '../../_constants';
import { confirmAlert } from 'react-confirm-alert';

class Aplications extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataLoaded: false,
      aplications: [],
    };
    this.requestEditAccess = this.requestEditAccess.bind(this);
  }

  componentDidMount() {
    this.props.dispatch(apis.getaplications());
  }

  componentDidUpdate(prevProps) {
    const { api } = this.props;

    // Redirect if unauthorized
    if (api?.UNAUTHROIZED && api.UNAUTHROIZED !== prevProps.api?.UNAUTHROIZED) {
      localStorage.clear();
      window.location.assign('/job-application');
    }

    // Update state when applications are received
    if (api?.aplications && api.aplications !== prevProps.api?.aplications) {
      this.setState({
        aplications: api.aplications,
        application: api.aplications.data?.[0] || null,
        dataLoaded: true,
      });
    }

    // Show error alert once
    if (
      api?.edit_access_error &&
      api.edit_access_error !== prevProps.api?.edit_access_error
    ) {
      confirmAlert({
        title: 'Failed to send request',
        message: api.edit_access_error,
        buttons: [{ label: 'Ok' }],
      });
    }

    // Show success alert once
    if (
      api?.edit_access_success &&
      api.edit_access_success !== prevProps.api?.edit_access_success
    ) {
      confirmAlert({
        title: 'Request Sent',
        message: 'Your request for edit access was sent successfully.',
        buttons: [{ label: 'Ok' }],
      });
    }
  }

  requestEditAccess() {
    confirmAlert({
      title: 'Request for Edit Access',
      message:
        'Your job application is currently under review. Would you like to request for edit access?',
      buttons: [
        { label: 'Cancel' },
        {
          label: 'Submit',
          onClick: () => {
            this.props.dispatch(apis.requestEditAccess());
          },
        },
      ],
    });
  }

  tab(index) {
    const tabs = [
      'personal-info',
      'preferences',
      'qualification',
      'experience',
      'driver-qualification',
      'hsq-document',
      'legal-remarks',
    ];
    return tabs[index - 1] || tabs[0];
  }

  status(status) {
    switch (status) {
      case 1:
        return 'Received';
      case 2:
        return 'Completed';
      case 3:
        return 'In review';
      case 4:
        return 'Offered Position';
      case 10:
      case 0:
        return 'Denied';
      case -1:
        return 'Incomplete';
      default:
        return '';
    }
  }

  render() {
    const { dataLoaded, aplications } = this.state;
    const appList = aplications?.data || [];

    const currentApplication = appList;
    const previousApplications = appList;

    if (dataLoaded && currentApplication.length === 0) {
      return <Redirect to='/job-application/new-application/personal-info' />;
    }

    return (
      <div className='aplcn-body'>
        <div className='container'>
          <FormHeader back={false} active={this.props.tab} hidetabs={true} />
          {!dataLoaded && (
            <div className='aplcn-form-data-prefetch'>Loading list..</div>
          )}

          {dataLoaded && (
            <div className='row-s row-main'>
              {currentApplication.map(
                (item) =>
                  item.active === 1 && (
                    <div
                      key={'aplication_' + item.hash}
                      className='aplcn-list-inner-wrapper'
                    >
                      <div className='row aplcn-block-aplication'>
                        <div className='col-12 col-xs-12 col-md-3 aplcn-name-block'>
                          <div className='aplcn-name-box'>
                            <span
                              data-label={util.avatar(
                                item.first_name + ' ' + item.last_name,
                              )}
                              className='aplcn-name-wrapper'
                            >
                              {item.first_name} {item.last_name}
                            </span>
                          </div>
                        </div>

                        <div className='col-12 col-xs-12 col-md-2 aplcn-detail-block aplcn-detail-name-block'>
                          <div className='aplcn-row-split'>Status</div>
                          <div
                            className={
                              'aplcn-row-split status status-' +
                              this.status(item.status)
                            }
                          >
                            {this.status(item.status)}
                          </div>
                        </div>

                        <div className='col-12 col-xs-12 col-md-2 aplcn-detail-block'>
                          <div className='aplcn-row-split'>Submitted on</div>
                          <div className='aplcn-row-split'>
                            {util.formatDate(item.date)}
                          </div>
                        </div>

                        <div className='col-12 col-xs-12 col-md-2 aplcn-detail-block aplcn-detail-block-end'>
                          <div className='aplcn-row-split'>Last Edited</div>
                          <div className='aplcn-row-split'>
                            {util.formatDate(item.updated_at)}
                          </div>
                        </div>

                        <div className='col-12 col-xs-12 col-md-2 aplcn-detail-block aplcn-detail-block-end'>
                          {!(
                            item.status === jobApplicationStatus.IN_REVIEW ||
                            item.status ===
                              jobApplicationStatus.OFFERED_POSITION
                          ) ||
                          (item.edit_status ===
                            jobApplicationEditStatus.APPROVED &&
                            (item.status === jobApplicationStatus.IN_REVIEW ||
                              item.status ===
                                jobApplicationStatus.OFFERED_POSITION)) ? (
                            <Link
                              className='aplcn-open-aplication-tab'
                              to={
                                '/job-application/' +
                                item.hash +
                                '/' +
                                this.tab(item.step)
                              }
                            >
                              {new Date(item.date).getFullYear() <
                              new Date().getFullYear() ? (
                                <button className='green-btn'>
                                  <span className='aplcn-button-label-edit'>
                                    Reapply For {new Date().getFullYear() + 1}{' '}
                                    Season
                                  </span>
                                </button>
                              ) : (
                                item.can_apply && (
                                  <div>
                                    <i className='fa fa-edit aplcn-edit-icon' />{' '}
                                    <span className='aplcn-button-label-edit'>
                                      Edit Application
                                    </span>
                                  </div>
                                )
                              )}
                            </Link>
                          ) : (
                            item.can_apply && (
                              <div onClick={this.requestEditAccess}>
                                <i className='fa fa-edit aplcn-edit-icon' />{' '}
                                <span className='aplcn-button-label-edit'>
                                  Edit Application
                                </span>
                              </div>
                            )
                          )}
                        </div>
                      </div>
                    </div>
                  ),
              )}
            </div>
          )}

          {dataLoaded && previousApplications.some((h) => !h.active) && (
            <div className='history-list'>
              <div className='row'>
                <div className='col-md-12'>
                  <h4 className='title'>Previous Application History</h4>
                </div>
              </div>
              <div className='row'>
                {previousApplications.map(
                  (history, index) =>
                    !history.active && (
                      <div
                        key={`history_${history.hash}`}
                        className='col-md-12 history-item'
                      >
                        <div className='row-wrap'>
                          <div className='row'>
                            <div className='col-sm-4 col-md-3'>
                              <div className='sub-title'>
                                {index === 0 ? 'Last ' : ''}Application Status
                              </div>
                              <div className='desc'>
                                {this.status(history.status)}
                              </div>
                            </div>
                            <div className='col-sm-4 col-md-9'>
                              <div className='sub-title'>
                                {index === 0 ? 'Last ' : ''}Applied Date
                              </div>
                              <div className='desc'>
                                {util.formatDate(history.date)}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ),
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return state;
}

const connectedApp = connect(mapStateToProps)(Aplications);
export { connectedApp as Aplications };
